import type { MaybeRef } from 'vue'

export {
  FAILED_RUN_STATUSES,
  TERMINAL_RUN_STATUSES,
} from '@foodlista/trigger-vue'

export const OPERATIONS_CACHE_KEYS = {
  envelopes: (restaurantSlug: MaybeRef<string | undefined>) =>
    ['boc', 'envelopes', restaurantSlug] as const,
  realtimeToken: (restaurantSlug: MaybeRef<string | undefined>) =>
    ['boc', 'token', restaurantSlug] as const,
}

export const REALTIME_TOKEN_REFRESH_MS = 14 * 60 * 1000
